import { defineAsyncComponent } from 'vue'

export default defineAsyncComponent(() => import('./CardsTile.vue'))

// Re-export CardSelection enum for type-safe usage in feature components
export enum CardSelection {
  None = 'none',
  Single = 'single',
  Multiple = 'multiple'
}
